import { useEffect } from 'react';

export function useJsonLd(id: string, json: string | null) {
  useEffect(() => {
    const existing = document.getElementById(id);
    if (!json) {
      if (existing) existing.remove();
      return;
    }
    let el = existing as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.type = 'application/ld+json';
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = json;

    return () => {
      const node = document.getElementById(id);
      if (node) node.remove();
    };
  }, [id, json]);
}